import*as t from"./ExhaustiveSwitch.js";function e(e){return function(e){return new t.ExhaustiveSwitchInstance(e,[])}}export{e as default};
//# sourceMappingURL=useEffect.js.map